import React, { FC } from 'react'
import { Grid } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { RightPanel } from './RightPanel'
import { LeftPanel } from './LeftPanel'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  main: {
    width: '100%',
    minHeight: 'calc(100vh - 248px)',
  },
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    maxWidth: 1184,
    margin: '0 auto',
  },
}))

export const Contact: FC = () => {
  const classes = useStyles()
  return (
    <main className={classes.main}>
      <Grid container className={classes.container}>
        <Grid item xs={6}>
          <LeftPanel />
        </Grid>

        <Grid item xs={6}>
          <RightPanel />
        </Grid>
      </Grid>
    </main>
  )
}
